import { createReducer, on } from '@ngrx/store'
import { FilterState } from './filter.state'
import { FilterActions } from './filter.actions'

function getInitState(): FilterState {
  return {
    type: 'all',
    date: '',
    status: '',
    name: '',
  }
}

export const filterReducer = createReducer<FilterState>(
  getInitState(),
  on(FilterActions.resetAction, (): FilterState => getInitState()),
  on(
    FilterActions.changeTypeAction,
    (state, action): FilterState => ({
      ...state,
      type: action.payload,
    }),
  ),
  on(
    FilterActions.changeDateAction,
    (state, action): FilterState => ({
      ...state,
      date: action.payload,
    }),
  ),
  on(
    FilterActions.changeStatusAction,
    (state, action): FilterState => ({
      ...state,
      status: action.payload,
    }),
  ),
  on(
    FilterActions.changeNameAction,
    (state, action): FilterState => ({
      ...state,
      name: action.payload,
    }),
  ),
)
